import {asResponse} from '../util'
import axios from 'axios'

export const SUBSCRIPTION_SWR_KEY = '/bff/subscription'

export const getSubscription = async (url) => {
  const resp = await asResponse(axios.get(url))
  return {
    subscription: resp.data
  }
}

export const INVOICE_PREVIEW_SWR_KEY = ({customerId, plan, seats, confirmationTimestamp}) => [
  '/bff/subscription/invoice-preview',
  customerId,
  plan,
  seats,
  confirmationTimestamp
]

export const getInvoicePreview = async (url, customerId, plan, seats) => {
  const resp = await asResponse(axios.post(url, {
    customerId,
    plan,
    seats
  }))
  return {plan, invoicePreview: resp.data}
}

export const updatePaymentMethod = async (paymentMethodId) => {
  const resp = await asResponse(axios.post('/bff/subscription/payment-method', {paymentMethodId}))
  return resp.data
}

export const removePaymentMethod = async (paymentMethodId) => {
  const resp = await asResponse(axios.delete(`/bff/subscription/payment-method/${paymentMethodId}`))
  return resp.data
}

export const updatePlan = async (prorationDate, plan) => {
  const resp = await asResponse(axios.put(`/bff/subscription/plan`, {prorationDate, plan}))
  return resp.data
}